import React, { useEffect, useRef, useState } from "react";

// Freehand signature canvas. Exports a transparent PNG data URL via onChange.
export default function SignaturePad({ width = 480, height = 180, onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const lastPoint = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.lineWidth = 2.2;
    ctx.strokeStyle = "#1a2a6c";
  }, [width, height]);

  const pointFromEvent = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

  const emit = () => {
    if (onChange) onChange(canvasRef.current.toDataURL("image/png"));
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    lastPoint.current = pointFromEvent(e);
    canvasRef.current.setPointerCapture?.(e.pointerId);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const point = pointFromEvent(e);
    ctx.beginPath();
    ctx.moveTo(lastPoint.current.x, lastPoint.current.y);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();
    lastPoint.current = point;
    if (isEmpty) setIsEmpty(false);
  };

  const end = (e) => {
    if (!drawing.current) return;
    drawing.current = false;
    lastPoint.current = null;
    canvasRef.current.releasePointerCapture?.(e.pointerId);
    emit();
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
    setIsEmpty(true);
    if (onChange) onChange("");
  };

  return (
    <div className="sp-wrap">
      <canvas
        ref={canvasRef}
        className="sp-canvas"
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        onPointerCancel={end}
      />
      <div className="sp-actions">
        <span className="sp-hint">{isEmpty ? "Draw the signature above with mouse, pen or finger." : "Signature captured."}</span>
        <button type="button" className="cp-modal-cancel" onClick={clear}>Clear</button>
      </div>
    </div>
  );
}
